import React, { useState } from 'react';

import FPS_Auth_Time from './FPS_Auth_Time'
import GetDistricts from '../../Dropdowns/getDistricts';
// import GetFpsId from'../Dropdowns/getFpsId';
import GetAfsoo from "../../Dropdowns/getAfsoo";

const FPS_Auth_Interface = ({ }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); // Manage loading state
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [selectedDist, setSelectedDist] = useState('');
    const [loadingFpsId, setLoadingFpsId] = useState(false);
    const [selectedAfso, setSelectedAfso] = useState("");
    const [loadingAfso, setLoadingAfso] = useState(false);
    const [selectedDate, setSelectedDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    });




    const handleDistrictChange = (dist_code) => {
        setSelectedDist(dist_code);
    };
    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const handleAfsoChange = (afso_code) => {
        setSelectedAfso(afso_code);
    };


    const handleSubmit = () => {
        if (!selectedDist) {
            alert("Please select District");
        } else if (!selectedAfso) {
            alert("Please select AFSO");
        } else if (!selectedDate) {
            alert("Please select Date");
        } else {
            setRenderContent(
                <FPS_Auth_Time
                    dist_code={selectedDist}
                    afso={selectedAfso}
                    date={selectedDate}
                />
            );
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>FPS Authentications</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>


                                    <td>District</td>
                                    <td>
                                        <GetDistricts
                                            onLoadingChange={setLoadingDistricts}
                                            onChange={handleDistrictChange}
                                        />
                                    </td>
                                    <td>AFSO</td>
                                    <td>
                                        {selectedDist ? (
                                            <GetAfsoo
                                                dist_code={selectedDist}
                                                onLoadingChange={setLoadingAfso}
                                                onChange={handleAfsoChange}
                                            />
                                        ) : (
                                            <select disabled>
                                                <option value=""></option>
                                            </select>
                                        )}
                                    </td>
                                    <td>Date</td>
                                    <td>
                                        <input
                                            id="pos_ob_date"
                                            type="date"
                                            value={selectedDate}
                                            onChange={(e) => setSelectedDate(e.target.value)}
                                        />
                                    </td>

                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                        <button onClick={handleSubmit} className="button button2">
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default FPS_Auth_Interface;
